import { gql } from '@apollo/client/core';

export const AGENT_FIELDS = gql`
  fragment AgentFields on Agent {
    id
    agencyName
    email
    name
  }
`;

export const OFFER_SHEET_CONTACT_FIELDS = gql`
  fragment OfferSheetContactFields on OfferSheetContact {
    id
    email
    name
    role
    createdAt
    updatedAt
  }
`;

export const EXPENSE_FIELDS = gql`
  fragment ExpenseFields on Expense {
    id
    name
    amount
    calculationType
    calculationValue
    editable
  }
`;

export const EXPENSE_CATEGORY_FIELDS = gql`
  fragment ExpenseCategoryFields on ExpenseCategory {
    id
    name
    totalExpenses
    variable
    editable
    expenses {
      ...ExpenseFields
    }
  }
  ${EXPENSE_FIELDS}
`;

export const LIST_FIELDS = gql`
  fragment ListFields on List {
    id
    name
    projected
    gross
    listType
  }
`;

export const OFFER_TICKET_FIELDS = gql`
  fragment OfferTicketFields on OfferTicket {
    id
    gross
    name
    price
    projected
    section
  }
`;

export const TEMPLATE_FIELDS = gql`
  fragment TemplateFields on Template {
    id
    templateName
  }
`;

export const SUMMARY_FIELDS = gql`
  fragment SummaryFields on Summary {
    artistPotential
    breakeven
    fixedExpenses
    gbor
    netPotential
    overage
    promoterPotential
    splitPoint
    variableExpenses
  }
`;

/**
 * The whole sheet, minus the two fields AppSchema does not carry -- `htmlContent` and
 * `pdfDownloadUrl` come from `Api.fetchOfferSheetRendering` on the legacy schema.
 */
export const SHEET_FIELDS = gql`
  fragment SheetFields on Sheet {
    id
    name
    offerDate
    offerExpirationDate
    artistName
    attendeeCount
    billing
    dealArtistGuarantee
    dealGborPercentage
    dealType
    doorTime
    endTime
    eventGroupId
    exclusivity
    listCount
    lockedAt
    merch
    minimumAge
    note
    performanceDatesDescription
    promoterName
    promoterProfitPercentage
    startTime
    support
    supportGuarantee
    taxPercentage
    ticketCount
    venueAddress
    venueLogo
    venueName
    venueTimezone
    agent {
      ...AgentFields
    }
    contacts {
      ...OfferSheetContactFields
    }
    expenseCategories {
      ...ExpenseCategoryFields
    }
    lists {
      ...ListFields
    }
    lockedBy {
      name
    }
    summary {
      ...SummaryFields
    }
    tickets {
      ...OfferTicketFields
    }
    versions {
      id
      version
      versionName
    }
  }
  ${AGENT_FIELDS}
  ${OFFER_SHEET_CONTACT_FIELDS}
  ${EXPENSE_CATEGORY_FIELDS}
  ${LIST_FIELDS}
  ${OFFER_TICKET_FIELDS}
  ${SUMMARY_FIELDS}
`;
